var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.028 22H8.6673C6.35856 22 4.48695 20.214 4.48695 18.0108V13.133C4.48695 12.4248 4.19213 11.7456 3.66734 11.2448C2.45146 10.0845 2.60953 8.16205 4.00016 7.19692L10.3889 2.763C11.8547 1.74567 13.8406 1.74567 15.3064 2.763L21.6951 7.19691C23.0858 8.16205 23.2439 10.0845 22.028 11.2448C21.5032 11.7456 21.2084 12.4248 21.2084 13.133V18.0108C21.2084 20.214 19.3368 22 17.028 22ZM10.8477 17.25C10.4334 17.25 10.0977 17.5858 10.0977 18C10.0977 18.4142 10.4334 18.75 10.8477 18.75H14.8477C15.2619 18.75 15.5977 18.4142 15.5977 18C15.5977 17.5858 15.2619 17.25 14.8477 17.25H10.8477Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e7532b9e.svg";
export { ForwardRef as ReactComponent };